<template>
    <div class="">
        <!-- create track -->
        <div class="tw-flex" v-if="timeBlocks.length > 0">
            <div class="tw-w-1/2 tw-mr-4">
                <bordered-input>
                    <template #label>
                        <slot name="label"></slot>
                    </template>
                    <template #input>
                        <treeselect
                            v-model="model"
                            :name="name"
                            :options="costCenters"
                            :disable-branch-nodes="disableBranchNodes"
                            search-nested
                            noResultsText="Nichts gefunden"
                            placeholder="Kostenträger"
                        >
                            <div slot="value-label" slot-scope="{ node }">
                                <span v-html="getAncestors(node)"></span>
                                {{ node.raw.label }}
                            </div>
                        </treeselect>
                    </template>
                </bordered-input>
            </div>

            <div class="tw-w-1/2 tw-ml-4">
                <bordered-input>
                    <template #label><label for="choose-timeblocks">Arbeitszeitblock auswählen</label></template>
                    <template #input>
                        <select id="choose-timeblocks" class="" name="time_block_id">
                            <option :key="timeBlock.id" :value="timeBlock.id" v-for="timeBlock in timeBlocks">
                                {{ timeBlock.name }}
                            </option>
                        </select>
                    </template>
                </bordered-input>
            </div>
        </div>
        <!-- edit track -->
        <div v-if="timeBlocks.length == 0">
            <bordered-input>
                <template #label>
                    <slot name="label"></slot>
                </template>
                <template #input>
                    <treeselect
                        v-model="model"
                        :name="name"
                        :options="costCenters"
                        :disable-branch-nodes="disableBranchNodes"
                        search-nested
                        noResultsText="Nichts gefunden"
                        placeholder="Kostenträger"
                    >
                        <div slot="value-label" slot-scope="{ node }">
                            <span v-html="getAncestors(node)"></span>
                            {{ node.raw.label }}
                        </div>
                    </treeselect>
                </template>
            </bordered-input>
        </div>

    </div>
</template>

<script>
import BorderedInput from './BorderedInput.vue'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    name: "CustomCostCarrier",
    components: {
        BorderedInput,
        Treeselect,
    },

    props: {
        costCenters: Array,
        name: String,
        value: String,
        disableBranchNodes: Boolean
    },

    data() {
        return {
            model: null,
            timeBlocks: [],
        }
    },

    watch: {
        model(val) {
            if (window.Worklog && window.Worklog.costCarrier) {
                let projectId = window.Worklog.costCarrier[val];

                if (window.Worklog.timeBlocks[projectId]) {
                    this.timeBlocks = window.Worklog.timeBlocks[projectId]
                } else {
                    this.timeBlocks = []
                }
            }
        }
    },

    methods: {
        getAncestors({ancestors}) {
            let prependString = '';

            ancestors.slice().reverse().forEach(node => {
                prependString += `${node.raw.label} <span style="position: relative; top: -1px; padding: 0 2px;">›</span> `
            })

            return prependString;
        }
    },

    mounted() {
        // prefill old values
        this.model = this.value ? this.value : null

        // sorry 4 dirty hack. Listen for cost carrier prefill change from jquery
        this.$root.$on('prefill-cost-carrier', costCarrierId => {
            this.model = costCarrierId;
        });

        if (typeof window.Worklog !== 'undefined') {
            let {lastWorktimeEntry: wte} = window.Worklog;

            // prefill last chosen cost carrier
            if (wte && wte.cost_carrier_id) {
                this.model = wte.external_cost_carrier_id ?
                    wte.external_cost_carrier_id :
                    wte.cost_carrier_id
            }
        }
    }
}
</script>

<style>
/* make the placeholder black so it matches other selects */
.vue-treeselect__placeholder {
    color: black;
}

.vue-treeselect--focused .vue-treeselect__placeholder {
    color: #BDBDBD;
}
</style>